import React, { useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { MdKeyboardArrowRight } from "react-icons/md";
import "./SideBar.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const Sidebar = () => {
  const location = useLocation()
  const nav = useNavigate()
  useEffect(() => {
    // handleClick('/affliate/userlist')
  }, [])
  const [activePage, setActivePage] = useState('');
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliateAddPermission, setAddAffliatePermisssion] = useState(false);
  const [commissionGroupPermission, setCommmissionGroupPermission] = useState(false);
  const [affliateGroupPermission, setAffliateGroupPermission] = useState(false);
  const [affliateReviewPermission, setAfffliateReviewPermisssion] = useState(false);
  const [userCreatePermisssion, setUserCreatePermisssion] = useState(false);
  const [createCompaignPermission, setCreatCompaignPermission] = useState(false);
  const [mediaAddPermisssion, setMediaAddPermission] = useState(false);
  const [createCreatAffliateGroupPermisssion, setCreatAffliateGroupPermisssion] = useState(false)
  const [createCommissionGroupPermission, setCreatCommissionGroupPermisssion] = useState(false)
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  useEffect(() => {
    setAddAffliatePermisssion(checkPermission(affliate, "aff_add_affiliate"));
    setAfffliateReviewPermisssion(checkPermission(affliate, "aff_affiliate_review"));
    setUserCreatePermisssion(checkPermission(affliate, "set_add_user"));
    setCreatCompaignPermission(checkPermission(affliate, "mkt_create_campaign"))
    setMediaAddPermission(checkPermission(affliate, "mkt_create_media"))
    setCreatAffliateGroupPermisssion(checkPermission(affliate, "aff_add_affiliate_group"))
    setCreatCommissionGroupPermisssion(checkPermission(affliate, "aff_create_commission_group"))

  }, [affliate])
  const handleClick = (id) => {
    setActivePage(id);
    nav(id)
  };

  useEffect(() => {
    setActivePage(location.pathname)
  }, [location.pathname])

  return (
    <>
      <Navbar expand="lg" className="flex-column border-bottom-slidebar">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="flex-column justify-content-start">


            {
              window.location.pathname === "/affiliate/affliateliste" || window.location.pathname === "/affiliate/add-aff" ||
                window.location.pathname === "/affiliate/affreview" || window.location.pathname === "/affiliate/postback" ||
                window.location.pathname === "/affiliate/trems-condition" || window.location.pathname === "/affiliate/payment/history" ||
                window.location.pathname === "/affiliate/payment/user-invoices" || window.location.pathname === "/affiliate/payment/user-invoices-status" ||
                window.location.pathname === "/affiliate/settings/create-user" || window.location.pathname === "/affiliate/settings/user-list" ||
                window.location.pathname === "/affiliate/settings/user-LINK" || window.location.pathname === "/affiliate/details" || window.location.pathname === "/affiliate/details/group" || window.location.pathname === "/affiliate/details/bonus" || window.location.pathname === "/affiliate/details/affgrp" || window.location.pathname === "/affiliate/details/fixedCommissions" || window.location.pathname === "/affiliate/details/promo"
                || window.location.pathname === "/affiliate/details/affsites" || window.location.pathname === "/affiliate/affiliate-players" || window.location.pathname === "/affiliate/settings/mailing-templates" || window.location.pathname === "/affiliate/details/affApk" || window.location.pathname === "/affiliate/details/afflinkdomain" || window.location.pathname === "/affiliate/settings/users/details" || window.location.pathname === "/affiliate/settings/mailing-templates/create" || window.location.pathname === "/affiliate/settings/mailing-templates/edit"
                ?

                (
                  <>


                    <Nav.Link
                      to="/affiliate/affliateliste"
                      onClick={() => handleClick('/affiliate/affliateliste')}
                      className={activePage === '/affiliate/affliateliste' ? 'active list-style-none' : 'list-style-none'}
                    >
                      <div className="d-flex text-start fw-semibold">
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/affliateliste' ? 'icon-active' : ''} />
                        Affiliate list
                      </div>
                    </Nav.Link>

                    {affliateAddPermission ? (
                      <Nav.Link
                        to='/affiliate/add-aff'
                        onClick={() => handleClick('/affiliate/add-aff')}
                        className={activePage === '/affiliate/add-aff' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/add-aff' ? 'icon-active' : ''} />
                          Add Affiliate
                        </div>
                      </Nav.Link>
                    ) : (<></>)}
                    {affliateReviewPermission ? (
                      <Nav.Link
                        to="/affiliate/affreview"
                        onClick={() => handleClick('/affiliate/affreview')}
                        className={activePage === '/affiliate/affreview' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/affreview' ? 'icon-active' : ''} />
                          Affiliate review
                        </div>
                      </Nav.Link>
                    ) : (<></>)}
                    <Nav.Link
                      to="/affiliate/commission-groups"
                      onClick={() => handleClick('/affiliate/commission-groups')}
                      className={activePage === '/affiliate/commission-groups' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/commission-groups' ? 'icon-active' : ''} />
                        Commission groups
                      </div>
                    </Nav.Link>
                    <Nav.Link
                      to="/affiliate/aff-group"
                      onClick={() => handleClick('/affiliate/aff-group')}
                      className={activePage === '/affiliate/aff-group' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/aff-group' ? 'icon-active' : ''} />
                        Affiliate group
                      </div>
                    </Nav.Link>


                  </>
                ) : null
            }


            {
              window.location.pathname === "/affiliate/commission-groups" || window.location.pathname === "/affiliate/commission-create-group" || window.location.pathname === "/affiliate/commission/details" ?

                (
                  <>
                    <Nav.Link
                      to="/affiliate/commission-groups"
                      onClick={() => handleClick('/affiliate/commission-groups')}
                      className={activePage === '/affiliate/commission-groups' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/commission-groups' ? 'icon-active' : ''} />
                        Commission group list
                      </div>
                    </Nav.Link>
                    {createCommissionGroupPermission ? (

                      <Nav.Link
                        to="/affiliate/commission-create-group"
                        onClick={() => handleClick('/affiliate/commission-create-group')}
                        className={activePage === '/affiliate/commission-create-group' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/commission-create-group' ? 'icon-active' : ''} />
                          Create Commission group
                        </div>
                      </Nav.Link>) : (<></>)}
                  </>
                ) : null
            }



            {
              window.location.pathname === "/affiliate/aff-group" || window.location.pathname === "/affiliate/create-aff-group" || window.location.pathname === "/affiliate/affiliate-group/details" ?

                (
                  <>
                    <Nav.Link
                      to="/affiliate/aff-group"
                      onClick={() => handleClick('/affiliate/aff-group')}
                      className={activePage === '/affiliate/aff-group' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/aff-group' ? 'icon-active' : ''} />
                        Affiliate group
                      </div>
                    </Nav.Link>
                    {createCreatAffliateGroupPermisssion ? (
                      <Nav.Link
                        to="/affiliate/create-aff-group"
                        onClick={() => handleClick('/affiliate/create-aff-group')}
                        className={activePage === '/affiliate/create-aff-group' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/create-aff-group' ? 'icon-active' : ''} />
                          Create group
                        </div>
                      </Nav.Link>
                    ) : (<></>)}
                  </>
                ) : null

            }




            {
              window.location.pathname === "/affiliate/summary" || window.location.pathname === "/affiliate/promo-report" ||
                window.location.pathname === "/affiliate/full-report" || window.location.pathname === "/affiliate/player-report" ?
                (
                  <>
                    <Nav.Link
                      to="/affiliate/summary"
                      onClick={() => handleClick('/affiliate/summary')}
                      className={activePage === '/affiliate/summary' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/summary' ? 'icon-active' : ''} />
                        Summary
                      </div>
                    </Nav.Link>

                    <Nav.Link
                      to="/affiliate/full-report"
                      onClick={() => handleClick('/affiliate/full-report')}
                      className={activePage === '/affiliate/full-report' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/full-report' ? 'icon-active' : ''} />
                        Full report
                      </div>
                    </Nav.Link>

                    <Nav.Link
                      to="/affiliate/promo-report"
                      onClick={() => handleClick('/affiliate/promo-report')}
                      className={activePage === '/affiliate/promo-report' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/promo-report' ? 'icon-active' : ''} />
                        Promo material report
                      </div>
                    </Nav.Link>

                    <Nav.Link
                      to="/affiliate/player-report"
                      onClick={() => handleClick('/affiliate/player-report')}
                      className={activePage === '/affiliate/player-report' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/player-report' ? 'icon-active' : ''} />
                        Player report
                      </div>
                    </Nav.Link>


                  </>
                ) : null
            }


            {
              window.location.pathname === "/affiliate/marketing/campaigns" || window.location.pathname === "/affiliate/marketing/campaign-create" || window.location.pathname === "/affiliate/marketing/campaign/details" ?

                (
                  <>
                    <Nav.Link
                      to="/affiliate/marketing/campaigns"
                      onClick={() => handleClick('/affiliate/marketing/campaigns')}
                      className={activePage === '/affiliate/marketing/campaigns' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/marketing/campaigns' ? 'icon-active' : ''} />
                        Campaign list
                      </div>
                    </Nav.Link>
                    {createCompaignPermission ? (
                      <Nav.Link
                        to="/affiliate/marketing/campaign-create"
                        onClick={() => handleClick('/affiliate/marketing/campaign-create')}
                        className={activePage === '/affiliate/marketing/campaign-create' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/marketing/campaign-create' ? 'icon-active' : ''} />
                          Create Campaign
                        </div>
                      </Nav.Link>
                    ) : (<></>)}
                  </>
                ) : null

            }


            {
              window.location.pathname === "/affiliate/marketing/add-media" || window.location.pathname === "/affiliate/marketing/mass-media" ||
                window.location.pathname === "/affiliate/marketing/list-media" || window.location.pathname === "/affiliate/marketing/media/details" ?

                (
                  <>
                    {mediaAddPermisssion ? (
                      <Nav.Link
                        to="/affiliate/marketing/add-media"
                        onClick={() => handleClick('/affiliate/marketing/add-media')}
                        className={activePage === '/affiliate/marketing/add-media' ? 'active' : ''}
                      >
                        <div className='d-flex text-start fw-semibold'>
                          <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/marketing/add-media' ? 'icon-active' : ''} />
                          Add media
                        </div>
                      </Nav.Link>) : (<></>)}




                    <Nav.Link
                      to="/affiliate/marketing/list-media"
                      onClick={() => handleClick('/affiliate/marketing/list-media')}
                      className={activePage === '/affiliate/marketing/list-media' ? 'active' : ''}
                    >
                      <div className='d-flex text-start fw-semibold'>
                        <MdKeyboardArrowRight size={22} className={activePage === '/affiliate/marketing/list-media' ? 'icon-active' : ''} />
                        Media list
                      </div>
                    </Nav.Link>
                  </>
                ) : null

            }




          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Sidebar;
